import React, { useEffect, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const locales = { 'en-US': require('date-fns/locale/en-US') };
const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales });

export default function LeaveCalendar() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_PATH}loan/leavecalendar`) // your API
            .then(res => res.json())
            .then(data => {
                const formattedEvents = data.map(item => ({
                    title: item.title,
                    start: new Date(item.start),
                    end: new Date(item.end || item.start),
                    empcode: item.empcode,
                    status: item.status
                }));
                setEvents(formattedEvents);
            });
    }, []);

    return (
        <div style={{ height: 600, margin: '50px' }}>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
            />
        </div>
    );
}
